import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { color, container, fontSize, screen, spacing } from 'theme';

export const StyledWrapper = styled.div`
  background-color: ${color('midnight_100')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('sm')};
  padding: 0 ${spacing('md')} ${spacing('xl4')};
  margin: auto;

  @media (min-width: ${screen('md')}) {
    padding-left: ${spacing('xl')};
    padding-right: ${spacing('xl')};
  }
`;

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('lg')};
  text-align: center;
  font-size: ${fontSize('md')};
  line-height: 1.5;
  margin-bottom: ${spacing('md')};

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
    margin-bottom: ${spacing('xl2')};
  }

  > svg {
    width: ${spacing('xl4')};
    height: ${spacing('xl4')};
    margin: auto;
    color: ${color('navy_500')};
  }

  ${Heading2}:before {
    background-color: ${color('navy_500')};
  }

  p {
    color: ${color('text_subtle')};
  }

  p:first-of-type {
    margin-top: ${spacing('sm')};
  }

  p:last-of-type {
    margin-bottom: 0;
  }
`;
